module.exports = __webpack_public_path__ + "img/satellite.380e9cfe.png";